import React, { useState, useEffect } from "react";
import "./DelightCard.css";

const DelightCard: React.FC = () => {
  const [showCard, setShowCard] = useState<boolean>(false);

  useEffect(() => {
    // Simulate a delay for the card to appear
    const timer = setTimeout(() => {
      setShowCard(true);
    }, 500);

    return () => clearTimeout(timer); // Cleanup the timeout
  }, []);

  return (
    <div className={`delight-card ${showCard ? "visible" : ""}`}>
      <div className="delight-card-content">
        <h1 className="delight-card-title">🎉 Congratulations!</h1>
        <p className="delight-card-message">
          You've successfully completed your tasks for today. Great job!
        </p>
        <div className="delight-card-animation">🌟</div>
      </div>
    </div>
  );
};

export default DelightCard;
